import { frontendURL } from 'dashboard/helper/URLHelper';
import RankingIndex from './Ranking.vue';

// v106: Ranking de vendas (pódium do mês). Visibilidade decidida pelo
// Controle de Acesso (key 'Ranking' — nasce bloqueada p/ não-admins via
// backfill; o Kairo libera na tela).
export const routes = [
  {
    path: frontendURL('accounts/:accountId/ranking'),
    name: 'ranking_index',
    component: RankingIndex,
    meta: {
      permissions: [
        'administrator',
        'supervisor',
        'agent',
        'operacional',
        'qualidade',
        'ouvidoria',
        'juridico',
        'custom_role',
      ],
    },
  },
];

export default { routes };
